import { render } from "./NotificationItem.vue?vue&type=template&id=d68fb218&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"

import "./NotificationItem.vue?vue&type=style&index=0&id=d68fb218&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68fb218"]])

export default __exports__